export const selectProfileLoading = (state) => state?.profile?.loading;
export const selectMasjidDetails = (state) => state?.profile?.masjidData;
